// src/components/KonceptSelector.jsx
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllKoncepts } from "../slices/konceptsSlice";
import { setGatewayId, setWatchId, selectGatewayKoncepts, selectWatchKoncepts } from "../slices/selectionSlice";
import { fetchAllMetrics, clearMetrics } from "../slices/metricsSlice";
import "./KonceptSelector.css";

export default function KonceptSelector() {
  const dispatch = useDispatch();
  const konceptsStatus = useSelector((state) => state.koncepts.status);
  const gateways = useSelector(selectGatewayKoncepts);
  const watches = useSelector(selectWatchKoncepts);
  const { gatewayId, watchId } = useSelector((state) => state.selection);

  // On mount, fetch all koncepts
  useEffect(() => {
    if (konceptsStatus === "idle") {
      dispatch(fetchAllKoncepts());
    }
  }, [dispatch, konceptsStatus]);

  // Whenever gatewayId or watchId changes, re-fetch metrics
  useEffect(() => {
    if (gatewayId && watchId) {
      dispatch(fetchAllMetrics());
    } else {
      dispatch(clearMetrics());
    }
  }, [dispatch, gatewayId, watchId]);

  return (
    <div className="kentyou-koncept-selector">
      {/* Gateway Select */}
      <div className="kentyou-selector-group">
        <label className="kentyou-selector-label">Choose Gateway</label>
        <select
          className="kentyou-selector-dropdown"
          value={gatewayId || ""}
          onChange={(e) => dispatch(setGatewayId(e.target.value))}
        >
          <option value="" disabled>
            -- Select Gateway --
          </option>
          {gateways.map((g) => (
            <option key={g.id} value={g.id}>
              {g.id}
            </option>
          ))}
        </select>
      </div>

      {/* Watch Select */}
      <div className="kentyou-selector-group">
        <label className="kentyou-selector-label">Choose Watch</label>
        <select
          className="kentyou-selector-dropdown"
          value={watchId || ""}
          onChange={(e) => dispatch(setWatchId(e.target.value))}
        >
          <option value="" disabled>
            -- Select Watch --
          </option>
          {watches.map((w) => (
            <option key={w.id} value={w.id}>
              {w.id}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

